module.exports = __webpack_public_path__ + "static/assets/9da6513dc1123d401f7988476d6cfe12.png";